import { useState, useEffect } from "react";
import { isUserEmailVerified } from "@/lib/auth";
import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";

type VerificationStatus = {
  isVerified: boolean | undefined;
  isLoading: boolean;
};

export function useEmailVerificationStatus(): VerificationStatus {
  const { data: user } = useLoggedInUser();
  const [isVerified, setIsVerified] = useState<boolean>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    if (!user) {
      setIsLoading(false);
      setIsVerified(true); // Treat unauthenticated state as 'verified' not applicable for simplicity
      return;
    }

    async function checkVerification() {
      setIsLoading(true);
      try {
        const verified = await isUserEmailVerified();
        if (isMounted) {
          setIsVerified(verified);
        }
      } catch {
        if (isMounted) {
          setIsVerified(false);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    checkVerification();

    return () => {
      isMounted = false;
    };
  }, [user]);

  return {
    isVerified,
    isLoading,
  };
}
